/** Splits large bulk edits into the API's bounded transaction size. */
export function batchesOf<T>(items: T[], size = 200): T[][] {
  const batches: T[][] = [];
  for (let offset = 0; offset < items.length; offset += size) {
    batches.push(items.slice(offset, offset + size));
  }
  return batches;
}
